import { animate, style, transition, trigger } from "@angular/animations";

export function GrowTransition() {
	return trigger('grow', [
		transition(':enter', [
			style({width: '0'}),
			animate('.3s ease')
		]),
		transition(':leave', [
			animate(".3s ease",
				style(
					{ width: '0px' }
				)
			)
		])
	])
}
